import { useState } from "react";
// import { ReactComponent as Info } from "../../assets/icons/info.svg";
import { ReactComponent as Tip } from "../../assets/icons/tip.svg";
import { SvgIcon, Paper, Typography, Box, Popper } from "@material-ui/core";
import "./infotooltip.scss";

function InfoTooltip({ message }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleHover = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "info-tooltip" : undefined;

  return (
    <Box style={{ display: "inline-flex", justifyContent: "center", alignSelf: "center" }}>
      <SvgIcon
        component={Tip}
        // component={Info}
        onMouseOver={handleHover}
        onMouseOut={handleHover}
        // onClick={handleHover}
        style={{ margin: "0 5px" }}
        className="info-icon"
        viewBox="0 0 14 14"
      ></SvgIcon>
      <Popper id={id} open={open} anchorEl={anchorEl} placement="bottom" className="tooltip">
        <Paper className="info-tooltip ohm-card">
          <Typography variant="body2" className="info-tooltip-text">
            {message}
          </Typography>
        </Paper>
      </Popper>
    </Box>
  );
}

export default InfoTooltip;
